/**
 * School-facing / public copies of the portrait may omit a legacy
 * maturity score line prepended during older draft synthesis runs.
 */
export function stripInstitutionalMaturityFromExecutiveSummary(text) {
  if (!text || typeof text !== 'string') return '';
  return text
    .replace(/^INSTITUTIONAL MATURITY SCORE:\s*[\d.]+\/5\.00\s*(\n+|$)/i, '')
    .replace(/^Institutional Maturity Score:\s*[\d.]+\/5\.00\s*(\n+|$)/i, '')
    .trim();
}
